import React from 'react';
import { Helmet } from 'react-helmet';
import { Container, Row, Col, Image } from 'react-bootstrap';
import gradiente from '../../assets/invisibile/Gradiente.svg';
import exZanussi1 from '../../assets/invisibile/01.jpg';
import exZanussi2 from '../../assets/invisibile/02.jpg';
import logoRed from '../../assets/invisibile/Invisibile_red.svg';
import logoWhite from '../../assets/invisibile/Invisibile_white.svg';
import preview from '../../assets/preview.jpg';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

import AlessandroBeccagli from '../../assets/invisibile/Speaker/AlessandroBeccagli.jpg';
import AndreaDaRe from '../../assets/invisibile/Speaker/AndreaDaRe.jpg';
import CamillaFerrari from '../../assets/invisibile/Speaker/CamillaFerrari.jpg';
import EzioMicelli from '../../assets/invisibile/Speaker/EzioMicelli.jpg';
import GianlucaComandini from '../../assets/invisibile/Speaker/GianlucaComandini.jpg';
import GiorgiaSterza from '../../assets/invisibile/Speaker/GiorgiaSterza.jpg';
import LauraMartin from '../../assets/invisibile/Speaker/LauraMartin.jpg';
import LucianaDocarmo from '../../assets/invisibile/Speaker/LucianaDocarmo.jpg';
import PaoloTagliamento from '../../assets/invisibile/Speaker/PaoloTagliamento.jpg';
import SerenaFiorito from '../../assets/invisibile/Speaker/SerenaFiorito.jpg';



export default function Invisibile() {

    const cache0 = {};
    function importAll0(r) {
        r.keys().forEach((key) => (cache0[key] = r(key)));
    }
    importAll0(require.context("../../assets/invisibile/01_Main/", false, /\.(png|jpe?g|svg)$/));
    const logos0 = Object.entries(cache0).map(module => module[1]);


    const cache1 = {};
    function importAll1(r) {
        r.keys().forEach((key) => (cache1[key] = r(key)));
    }
    importAll1(require.context("../../assets/invisibile/02_Partner/", false, /\.(png|jpe?g|svg)$/));
    const logos1 = Object.entries(cache1).map(module => module[1]);


    const cache2 = {};
    function importAll2(r) {
        r.keys().forEach((key) => (cache2[key] = r(key)));
    }
    importAll2(require.context("../../assets/invisibile/03_Tecnical/", false, /\.(png|jpe?g|svg)$/));
    const logos2 = Object.entries(cache2).map(module => module[1]);


    const cache3 = {};
    function importAll3(r) {
        r.keys().forEach((key) => (cache3[key] = r(key)));
    }
    importAll3(require.context("../../assets/invisibile/04_Food/", false, /\.(png|jpe?g|svg)$/));
    const logos3 = Object.entries(cache3).map(module => module[1]);


    const cache4 = {};
    function importAll4(r) {
        r.keys().forEach((key) => (cache4[key] = r(key)));
    }
    importAll4(require.context("../../assets/invisibile/00_Patrocinio/", false, /\.(png|jpe?g|svg)$/));
    const logos4 = Object.entries(cache4).map(module => module[1]);


    const cache5 = {};
    function importAll5(r) {
        r.keys().forEach((key) => (cache5[key] = r(key)));
    }
    importAll5(require.context("../../assets/invisibile/04_Food/", false, /\.(png|jpe?g|svg)$/));
    const logos5 = Object.entries(cache5).map(module => module[1]);



    return (
        <>
            <Helmet>
                <title>Invisibile</title>
                <meta name="description" content="TEDxConegliano - Edizione: Invisibile" />
            </Helmet>


            <Container fluid className='mt-0 pt-0 ps-0 pe-0 bg-slide height-100 slide-gradient-light align-items-end' style={{ backgroundSize: 'inherit', backgroundRepeat: 'repeat', backgroundColor: '#000', backgroundImage: 'url(' + gradiente + ')' }}>
                <Container fluid="md" className='text-start p-5 text-white' style={{ zIndex: 1 }}>
                    <h5>2025</h5>
                    <h1 className='mt-5 mb-5' style={{ maxWidth: 700 }}>
                        INVISIBILE - Oltre quello che si vede<br />
                        28 Giugno 2025
                    </h1>

                    <p className='lead' style={{ maxWidth: 700 }}>
                    Viviamo immersi in forze, strutture e connessioni che non vediamo.<br/>
                    Lʼinvisibile non è assenza, ma presenza silenziosa: è ciò che costruisce il
                    nostro mondo senza mostrarsi.<br/>
                    Con questa edizione di TEDxConegliano esploriamo quello che esiste, anche
                    quando i nostri occhi non riescono a coglierlo.
                    </p>

                    <div className='mt-5 mb-5'>
                        <a href='#rivivi_evento'>
                            <span className='button-52-light m-auto'>
                                Rivivi l'evento
                            </span>
                        </a>
                    </div>

                </Container>
            </Container>


            <Container fluid className='pt-5 pb-5 ps-0 pe-0 height-100'>
                <Container fluid="md" className='text-start p-5'>
                    <Row className='align-items-center'>
                        <Col xs={12} lg={5}>
                            <h5 style={{ fontWeight: 600, color: '#eb0028' }}>TEDxConegliano</h5>
                            <h3 className='mt-5 mb-5' style={{ maxWidth: 700 }}>
                                Cosa significa
                                invisibile per noi?
                            </h3>

                            <p className='mb-5 lead'>
                                Invisibile è tutto ciò che plasma la realtà senza mostrarsi.
                                Forze, strutture, idee che esistono anche se non riusciamo
                                a coglierle con lo sguardo.
                            </p>

                            <p className='mb-5'>
                                Per raccontarlo, abbiamo scelto il frattale: una forma geometrica che si
                                ripete allʼinfinito, generata da regole semplici e costruita grazie ai numeri
                                complessi.<br/>
                                Avvicinandosi al centro del frattale, le geometrie si fondono, si
                                confondono, sfuggono alla chiarezza.<br/>
                                Proprio in quel punto — dove la visione si dissolve — nasce la vera natura
                                dell'invisibile: un limite che il nostro ingegno prova a superare, per dare
                                forma a ciò che, a prima vista, sembra indefinito.
                            </p>
                        </Col>
                        <Col xs={12} lg={1}></Col>
                        <Col xs={12} lg={6} className='text-center'>
                            <Image src={logoRed} height={430} width={330}/>
                        </Col>
                    </Row>
                </Container>
            </Container>


            <Container fluid className='pt-5 pb-5 ps-0 pe-0 bg-slide height-100 slide-gradient-black' style={{ backgroundColor: '#000' }}>
                <Container fluid="md" className='text-start p-5 text-white' style={{ zIndex: 1 }}>
                    <Row className='align-items-start'>
                        <Col xs={12} lg={2} className='pb-5'>
                            <h5 style={{ fontWeight: 600, color: '#eb0028' }}>TEDxConegliano</h5>
                        </Col>
                        <Col xs={12} lg={1}></Col>
                        <Col xs={12} lg={3} className='pb-5'>
                            <h3>
                                Vogliamo invitare tutti a
                                guardare oltre.
                            </h3>
                        </Col>
                        <Col xs={12} lg={1}></Col>
                        <Col xs={12} lg={5} className='pb-5'>
                            <p className='lead'>
                                A riconoscere il valore di ciò che non si vede.
                                A scoprire che spesso, proprio dove tutto
                                sembra confuso o indefinito, si nasconde il
                                centro, il fulcro, la verità.
                            </p>
                            <p>
                                Lʼinvisibile è il terreno su cui poggia tutto ciò che
                                conosciamo: comprenderlo è il primo passo per cambiare
                                la realtà.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </Container>


            <Container fluid className='pt-5 pb-5 ps-0 pe-0 bg-slide height-100' style={{ backgroundColor: '#eb0028' }}>
                <Container fluid="md" className='text-center p-5 text-white' style={{ zIndex: 1 }}>

                    <Image src={logoWhite} height={430} width={330}/>

                    <h1 className='mt-5 mb-5'>
                        Un viaggio oltre i confini della percezione.
                    </h1>

                    <p className='m-auto' style={{ maxWidth: 700 }}>
                        Un invito a esplorare ciò che esiste sotto la superficie, a dare forma a ciò che sfugge.<br/>
                        Attraverso le sfumature di TEDxConegliano 2025 apriremo uno spazio dove il visibile si intreccia con
                        lʼinvisibile, e dove la conoscenza diventa strumento per vedere di più, e meglio.
                    </p>

                    <div className='mt-5 mb-5'>
                        <a href="#rivivi_evento">
                            <span className='button-52-light red m-auto'>
                                Rivivi l'evento
                            </span>
                        </a>
                    </div>

                </Container>
            </Container>


            <Container fluid className='pt-5 pb-5 ps-0 pe-0'>
                <Container fluid="md" className='text-start p-5'>
                    <Row className='align-items-start'>
                        <Col xs={12} lg={3} className='pb-5'>
                            <h5 style={{ fontWeight: 600, color: '#eb0028' }}>SPEAKER</h5>
                            <p>
                                Persone e idee che possono
                                cambiare il nostro modo di vedere,
                                aiutandoci a riconoscere e
                                valorizzare ciò che, pur restando
                                invisibile, costruisce il nostro
                                presente e il nostro futuro.
                            </p>
                        </Col>
                        <Col xs={12} lg={1}></Col>
                        <Col xs={12} lg={8} className='pb-5'>
                            <Row className='mt-5'>
                                <Col xs={6} lg={4} className='mb-5'>
                                    <Image src={LucianaDocarmo} width={'100%'} />
                                    <p style={{ fontWeight: 600 }} className='lead mt-4 mb-1'>LUCIANA DO CARMO BRAGA</p>
                                    <p className='text-muted'>
                                        Ex pallavolista professionista a
                                        Conegliano. Coach sportivo e del
                                        mentoring per giovani atleti
                                        professionisti.
                                    </p>
                                </Col>
                                <Col xs={6} lg={4} className='mb-5'>
                                    <Image src={AlessandroBeccagli} width={'100%'} />
                                    <p style={{ fontWeight: 600 }} className='lead mt-4 mb-1'>ALESSANDRO BECAGLI</p>
                                    <p className='text-muted'>
                                        Pedagogista ed educatore
                                        professionale. Dal 2015 è
                                        presidente dellʼAssociazione Comunità giovanile ETS.
                                    </p>
                                </Col>
                                <Col xs={6} lg={4} className='mb-5'>
                                    <Image src={LauraMartin} width={'100%'} />
                                    <p style={{ fontWeight: 600 }} className='lead mt-4 mb-1'>LAURA MARTIN</p>
                                    <p className='text-muted'>
                                        Nata in Germania e cresciuta a
                                        Conegliano. Referente di
                                        comunicazione aerospaziale e
                                        tecnologie avanzate, presso
                                        unʼazienda di Monaco.
                                    </p>
                                </Col>
                                <Col xs={6} lg={4} className='mb-5'>
                                    <Image src={SerenaFiorito} width={'100%'} />
                                    <p style={{ fontWeight: 600 }} className='lead mt-4 mb-1'>SERENA FIORITO</p>
                                    <p className='text-muted'>
                                        Fisioterapista specializzata nella
                                        riabilitazione del dolore
                                        muscoloscheletrico, acuto e
                                        cronico.
                                    </p>
                                </Col>
                                <Col xs={6} lg={4} className='mb-5'>
                                    <Image src={PaoloTagliamento} width={'100%'} />
                                    <p style={{ fontWeight: 600 }} className='lead mt-4 mb-1'>PAOLO TAGLIAMENTO</p>
                                    <p className='text-muted'>
                                        Eʼ un violinista italiano. Si è
                                        diplomato nel 2013 a soli 15 anni
                                        con il massimo dei voti, lode e
                                        menzione speciale al
                                        Conservatorio di Musica Giuseppe
                                        Verdi (Milano).
                                    </p>
                                </Col>
                                <Col xs={6} lg={4} className='mb-5'>
                                    <Image src={EzioMicelli} width={'100%'} />
                                    <p style={{ fontWeight: 600 }} className='lead mt-4 mb-1'>EZIO MICELLI</p>
                                    <p className='text-muted'>
                                        Professore ordinario presso
                                        lʼUniversità IUAV di Venezia. Da
                                        oltre dieci anni studia i nuovi
                                        strumenti di valutazione e gestione
                                        per lo sviluppo della città.
                                    </p>
                                </Col>
                                <Col xs={6} lg={4} className='mb-5'>
                                    <Image src={AndreaDaRe} width={'100%'} />
                                    <p style={{ fontWeight: 600 }} className='lead mt-4 mb-1'>ANDREA DA RE</p>
                                    <p className='text-muted'>
                                        Esperto Cybercicurity.
                                        Responsabile sicurezza informatica
                                        Carraro group.
                                    </p>
                                </Col>
                                <Col xs={6} lg={4} className='mb-5'>
                                    <Image src={CamillaFerrari} width={'100%'} />
                                    <p style={{ fontWeight: 600 }} className='lead mt-4 mb-1'>CAMILLA FERRARI</p>
                                    <p className='text-muted'>
                                        Fotografa professionista. Ha
                                        pubblicato su National Geographic,
                                        The New York Times, Essenziale,
                                        NPR, US News, D – La Repubblica
                                        e Domus e molti altri.
                                    </p>
                                </Col>
                                <Col xs={6} lg={4} className='mb-5'>
                                    <Image src={GianlucaComandini} width={'100%'} />
                                    <p style={{ fontWeight: 600 }} className='lead mt-4 mb-1'>GIANLUCA COMANDINI</p>
                                    <p className='text-muted'>
                                        Eʼ tra i primi in Italia ad investire in
                                        due trend allora poco esplorati:
                                        blockchain e social media. Ora è
                                        uno dei principali divulgatori e
                                        opinion leader italiani del settore.
                                    </p>
                                </Col>
                                <Col xs={6} lg={4} className='mb-5'>
                                    <Image src={GiorgiaSterza} width={'100%'} />
                                    <p style={{ fontWeight: 600 }} className='lead mt-4 mb-1'>GIORGIA SFERZA</p>
                                    <p className='text-muted'>
                                        Innovation Manager GELLIFY.
                                        oltre 13 anni di esperienza
                                        internazionale sia nel contesto
                                        corporate che in startup nel campo
                                        dell'innovazione e della digital
                                        transformation.
                                    </p>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Container>


            <Container fluid className='pt-5 pb-5 ps-0 pe-0'>
                <Container fluid="md" className='text-start p-5'>
                    <Row className='align-items-start'>
                        <Col xs={12} lg={3} className='pb-5'>
                            <h5 style={{ fontWeight: 600, color: '#eb0028' }}>28 GIUGNO 2025</h5>
                            <p>Un tramonto nellʼinvisibile</p>
                        </Col>
                        <Col xs={12} lg={1}></Col>
                        <Col xs={12} lg={8} className='pb-5'>
                            <Row>
                                <Col xs={12} lg={4} className='p-4' style={{ backgroundColor: '#f3f3f3', border: '10px solid #fff' }}>
                                    <p style={{ color: '#eb0028' }} className='lead mt-4 mb-1 small'>ACCREDITI WORKSHOP</p>
                                    <h2 style={{ fontWeight: 500, color: '#eb0028' }} className='mt-5'>17:00</h2>
                                    <p className='text-muted small'>
                                        Accrediti riservati per possessori di
                                        biglietti con Workshop incluso.
                                    </p>
                                </Col>
                                <Col xs={12} lg={4} className='p-4' style={{ backgroundColor: '#f3f3f3', border: '10px solid #fff' }}>
                                    <p style={{ color: '#eb0028' }} className='lead mt-4 mb-1 small '>WORKSHOP</p>
                                    <h2 style={{ fontWeight: 500, color: '#eb0028' }} className='mt-5'>17:30</h2>
                                    <p className='text-muted small'>
                                        Svolgimento workshop in
                                        piccoli gruppi. Fino alle ore 18:30
                                    </p>
                                </Col>
                                <Col xs={12} lg={4} className='p-4' style={{ backgroundColor: '#f3f3f3', border: '10px solid #fff' }}>
                                    <p style={{ color: '#eb0028' }} className='lead mt-4 mb-1 small'>ACCREDITI GENERALI</p>
                                    <h2 style={{ fontWeight: 500, color: '#eb0028' }} className='mt-5'>17:45</h2>
                                    <p className='text-muted small'>
                                        Accrediti per tutti i biglietti.
                                        Fino alle ore 19:00
                                    </p>
                                </Col>
                                <Col xs={12} lg={4} className='p-4' style={{ backgroundColor: '#f3f3f3', border: '10px solid #fff' }}>
                                    <p style={{ color: '#eb0028' }} className='lead mt-4 mb-1 small'>TALKS</p>
                                    <h2 style={{ fontWeight: 500, color: '#eb0028' }} className='mt-5'>19:00</h2>
                                    <p className='text-muted small'>
                                        TEDxConegliano Talks
                                    </p>
                                </Col>
                                <Col xs={12} lg={4} className='p-4' style={{ backgroundColor: '#f3f3f3', border: '10px solid #fff' }}>
                                    <p style={{ color: '#eb0028' }} className='lead mt-4 mb-1 small'>A TASTE OF THE INVISIBLE</p>
                                    <h2 style={{ fontWeight: 500, color: '#eb0028' }} className='mt-5'>21:30</h2>
                                    <p className='text-muted small'>
                                        Rinfresco serale di condivisione.
                                    </p>
                                </Col>
                                <Col xs={12} lg={4} className='p-4' style={{ backgroundColor: '#f3f3f3', border: '10px solid #fff' }}>
                                    <p style={{ color: '#eb0028' }} className='lead mt-4 mb-1 small'>CONCLUSIONI</p>
                                    <h2 style={{ fontWeight: 500, color: '#eb0028' }} className='mt-5'>22:30</h2>
                                    <p className='text-muted small'>
                                        Ringraziamenti ei saluti
                                    </p>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Container>


            <Container fluid className='pt-5 pb-5 ps-0 pe-0 bg-slide height-100 slide-gradient-black' style={{ backgroundColor: '#eee', backgroundImage: 'url(' + exZanussi1 + ')' }}>
                <Container fluid="md" className='text-center p-5 text-white' style={{ zIndex: 1 }}>
                    <h5 style={{ fontWeight: 600, color: '#eb0028' }}>LOCATION</h5>
                    <h1 className='mt-5 mb-5'>
                        Ex Area Zanussi
                    </h1>

                    <p className='m-auto' style={{ maxWidth: 700 }}>
                        Ex cuore industriale di Conegliano, l’Area Zanussi ha segnato lo sviluppo della città.
                        Oggi, spazio sospeso tra memoria e futuro, diventa il palcoscenico ideale per raccontare l’invisibile.
                        Qui convivono il passato produttivo e il desiderio di nuove visioni.
                    </p>

                    <div className='mt-5 mb-5'>
                        <a href="#rivivi_evento">
                            <span className='button-52-light red m-auto'>
                                Rivivi l'evento
                            </span>
                        </a>
                    </div>

                </Container>
            </Container>


            <Container fluid className='pt-5 pb-5 ps-0 pe-0 height-100'>
                <Container fluid="md" className='text-start p-5'>
                    <Row className='align-items-center'>
                        <Col xs={12} lg={5}>
                            <h5 style={{ fontWeight: 600, color: '#eb0028' }}>TEDxConegliano</h5>
                            <p className='mt-5 mb-5 lead'>
                                Un luogo che unisce passato, presente e
                                futuro. Abbiamo scelto lʼex Area Zanussi
                                perché rappresenta un pezzo importante della
                                storia di Conegliano.
                            </p>

                            <p className='mb-5'>
                                Negli anni del suo massimo sviluppo industriale, questo
                                spazio ha contribuito alla crescita economica e sociale
                                della città, diventando un punto di riferimento per intere
                                generazioni.<br/>
                                Oggi, nel cuore della città, l'Area Zanussi è un luogo in
                                attesa di una nuova vocazione. Una presenza visibile ma
                                ancora sospesa, simbolo perfetto di quel confine sottile tra
                                ciò che è evidente e ciò che resta da immaginare.
                                <br /><br />
                                Attraverso TEDxConegliano vogliamo valorizzare questo
                                spazio, accendendo uno sguardo nuovo su di esso: un
                                invito a riconoscere il potenziale che abita anche ciò che,
                                per ora, sembra invisibile.
                            </p>
                        </Col>
                        <Col xs={12} lg={1}></Col>
                        <Col xs={12} lg={6} className='text-center'>
                            <Image src={exZanussi2} width={'100%'} />
                        </Col>
                    </Row>
                </Container>
            </Container>

                
            <Container fluid className='pt-5 pb-5 ps-0 pe-0' style={{ background: '#eb0028' }}>
                <Container fluid="md" className='text-center p-5 text-white'>
                    <h5>PARTNER</h5>
                    <h1 className='mt-5 mb-5 ms-auto me-auto' style={{ maxWidth: 760 }}>
                        I nostri partner, credono nel territorio e nei talenti che esso esprime.
                    </h1>

                    <p className='m-auto' style={{ maxWidth: 700 }}>
                        Con il loro sostegno, costruiamo insieme un futuro più luminoso, in cui la cultura è al centro del progresso e della crescita della comunità
                    </p>
                </Container>
            </Container>


            <Container fluid className='pt-5 pb-5 ps-0 pe-0'>
                <Container fluid="md" className='text-center p-5'>
                    <h5 style={{ color: '#eb0028' }}>CON IL PATROCINIO DI</h5>
                    <Row className='justify-content-center'>
                        {logos4.map((logo, i) => {
                            return (
                                <Col xs={6} md={2} className='p-3' key={i}>
                                    <Image src={logo} width={'100%'} />
                                </Col>
                            )
                        })}
                    </Row>

                    <h5 style={{ color: '#eb0028' }} className='mt-5'>I NOSTRI PARTNER</h5>

                    <Row className='justify-content-center'>
                        {logos0.map((logo, i) => {
                            return (
                                <Col xs={6} md={3} className='p-3' key={i}>
                                    <Image src={logo} width={'100%'} />
                                </Col>
                            )
                        })}
                    </Row>

                    <hr/>

                    <Row className='justify-content-center'>
                        {logos1.map((logo, i) => {
                            return (
                                <Col xs={6} md={3} className='p-3' key={i}>
                                    <Image src={logo} width={'100%'} />
                                </Col>
                            )
                        })}
                    </Row>

                    <hr/>

                    <Row className='justify-content-center'>
                        {logos2.map((logo, i) => {
                            return (
                                <Col xs={4} md={2} className='p-3' key={i}>
                                    <Image src={logo} width={'100%'} />
                                </Col>
                            )
                        })}
                    </Row>

                    <hr/>

                    <Row className='justify-content-center'>
                        {logos5.map((logo, i) => {
                            return (
                                <Col xs={4} md={2} className='p-3' key={i}>
                                    <Image src={logo} width={'100%'} />
                                </Col>
                            )
                        })}
                    </Row>
                </Container>
            </Container>



            <Container fluid className='pt-5 pb-5 ps-0 pe-0' style={{ background: '#eb0028' }} id="rivivi_evento">
                <Container fluid="md" className='text-center p-5 text-white'>
                    <h5>I TALK DI QUESTA EDIZIONE</h5>

                    <Row className='mt-5'>
                        <Col sm={6} md={6} lg={4} className='mt-4'>
                            <LiteYouTubeEmbed
                                id="ZlvIhU_bH3E"
                                title="Alessandro Beccagli | TEDxConegliano"
                                poster="maxresdefault"
                            />
                            <p className='mt-2 small'>Da fragili e invisibili a protagonisti del proprio futuro | Alessandro Beccagli</p>
                        </Col>
                        <Col sm={6} md={6} lg={4} className='mt-4'>
                            <LiteYouTubeEmbed
                                id="JryRJFQDD2I"
                                title="Ezio Micelli | TEDxConegliano"
                                poster="maxresdefault"
                            />
                            <p className='mt-2 small'>L’invisibile che costruisce le città | Ezio Micelli</p>
                        </Col>
                        <Col sm={6} md={6} lg={4} className='mt-4'>
                            <LiteYouTubeEmbed
                                id="CypYW9vkKDA"
                                title="Gian Luca Comandini | TEDxConegliano"
                                poster="maxresdefault"
                            />
                            <p className='mt-2 small'>Chi ha rubato il calcio ai bambini? | Gian Luca Comandini</p>
                        </Col>
                        <Col sm={6} md={6} lg={4} className='mt-4'>
                            <LiteYouTubeEmbed
                                id="qCe2k_C3VZg"
                                title="Laura Martin | TEDxConegliano"
                                poster="maxresdefault"
                            />
                            <p className='mt-2 small'>Diversa, non sbagliata. Il potere di riscrivere se stessi | Laura Martin</p>
                        </Col>
                        <Col sm={6} md={6} lg={4} className='mt-4'>
                            <LiteYouTubeEmbed
                                id="YM1aoc4uRQI"
                                title="Luciana Do Carmo | TEDxConegliano"
                                poster="maxresdefault"
                            />
                            <p className='mt-2 small'>Il tuo sogno può cambiare il mondo: la mia storia | Luciana Do Carmo</p>
                        </Col>
                        <Col sm={6} md={6} lg={4} className='mt-4'>
                            <LiteYouTubeEmbed
                                id="jXBnGywhFKw"
                                title="Giorgia Sterza | TEDxConegliano"
                                poster="maxresdefault"
                            />
                            <p className='mt-2 small'>L’innovazione invisibile: vedere dove altri non guardano | Giorgia Sterza</p>
                        </Col>
                        <Col sm={6} md={6} lg={4} className='mt-4'>
                            <LiteYouTubeEmbed
                                id="wzLltPz_t7E"
                                title="Paolo Tagliamento | TEDxConegliano"
                                poster="maxresdefault"
                            />
                            <p className='mt-2 small'>La Musica invisibile | Paolo Tagliamento</p>
                        </Col>
                        <Col sm={6} md={6} lg={4} className='mt-4'>
                            <LiteYouTubeEmbed
                                id="YPCIUMFMppc"
                                title="Andrea Da Re | TEDxConegliano"
                                poster="maxresdefault"
                            />
                            <p className='mt-2 small'>Il paradosso della realtà invisibile | Andrea Da Re</p>
                        </Col>
                        <Col sm={6} md={6} lg={4} className='mt-4'>
                            <LiteYouTubeEmbed
                                id="gRr-uCNosKU"
                                title="Camilla Ferrari | TEDxConegliano"
                                poster="maxresdefault"
                            />
                            <p className='mt-2 small'>La fotografia apre portali invisibili | Camilla Ferrari</p>
                        </Col>
                        <Col sm={6} md={6} lg={4} className='mt-4'>
                            <LiteYouTubeEmbed
                                id="BL3Lxzvf41M"
                                title="Serena Fiorito | TEDxConegliano"
                                poster="maxresdefault"
                            />
                            <p className='mt-2 small'>Affrontare il dolore: il vero antidolorifico per tornare alla vita | Serena Fiorito</p>
                        </Col>
                    </Row>
                </Container>
            </Container>

            {/*
            <Container fluid className='pt-5 pb-5 ps-0 pe-0' style={{ background: '#fff' }} id="rivivi_evento">
                <Container fluid="md" className='text-center p-5 text-muted'>
                    <h5>RIVIVI L'EVENTO</h5>
                    <div className='mt-5'>
                        <LiteYouTubeEmbed
                            id="0CU_q0FwqAw"
                            title="TEDxConegliano - HERITAGE 2024"
                            poster="maxresdefault"
                            aspectHeight='140'
                            aspectWidth='384'
                        />
                    </div>
                </Container>
            </Container>
            */}

        </>
    );
};